import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '.';
import omit from 'lodash/omit';

export default class ToggleButton extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    formFieldLabel: PropTypes.string,
    getFormValue: PropTypes.func
  }

  get name() {
    return this.context.formFieldName || this.props.name
  }

  handleChange(e) {
    this.handleElementChange(e.target);
  }

  handleElementChange(value) {
    if (this.context.onChange) {
      this.context.onChange(this.name, value);
    }
  }

  componentDidMount() {
    this.handleElementChange(this.value);
  }

  get value() {
    return this.context.getFormValue(this.name);
  }

  get type() {
    const { type, selectedType } = this.props;

    if (type) {
      if (selectedType && this.value) {
        return selectedType;
      }

      return type;
    }

    if (this.value) {
      return 'weak'
    }

    return 'default';
  }

  render() {
    const { label } = this.props;

    return (
      <Button
        type={this.type}
        onClick={() => this.handleElementChange(!this.value)}
        {...omit(this.props, 'type', 'selectedType')}
      >
        {label}
      </Button>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/toggle-button.js